import React from 'react';

/**
 * Returns `value`, delayed until it has stopped changing for `delayMs`.
 *
 * For as-you-type filtering over a few hundred in-memory records the delay is not about
 * performance - it is about not re-ranking and re-rendering a dropdown on every keystroke while
 * someone is still typing.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
    const [debounced, setDebounced] = React.useState(value);

    React.useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
};

export default useDebouncedValue;
